(function ($, window, document, pi) {
    $('.extra-info-row .extra-info-title-container,.extra-info-row .extra-info-bookmark').matchHeight();
})(window.jQuery, window, document, window.patientInformation || {});